import React, { useEffect, useState } from "react";
import { Button, Checkbox, Collapse, message } from "antd";
import EntityLitigation from "./EntityLitigation/EntityLitigation";
import {
  getApplicationNoRecords,
  updateApplicationNoRecords,
} from "../../../../services/adminForm.services";
import { useQuery } from "../../../../helpers/utility";

const { Panel } = Collapse;

const NotableCourtRecords = (props) => {
  const query = useQuery();
  const applicationId = query.get("id");

  const [appNoRcd, setAppNoRcdData] = useState(null);
  const [checkBox, setCheckBox] = useState({
    no_ld_records: appNoRcd?.no_ld_records,
    no_jd_records: appNoRcd?.no_jd_records,
    no_jc_records: appNoRcd?.no_jc_records,
  });
  const [checked, setChecked] = useState({
    key: [],
  });
  useEffect(() => {
    getApplicationNoRecordsApi();
  }, [applicationId]);

  async function getApplicationNoRecordsApi() {
    try {
      const res = await getApplicationNoRecords(applicationId);
      setAppNoRcdData(res?.data?.data);
    } catch (err) {
      console.log(err);
    }
  }

  async function updateApplicationApi(values) {
    try {
      const res = await updateApplicationNoRecords(applicationId, {
        no_ld_records: values?.no_ld_records,
        no_jd_records: values?.no_jd_records,
        no_jc_records: values?.no_jc_records,
      });
      message.success(res.data?.message);
    } catch (err) {
      console.log(err);
    } finally {
      getApplicationNoRecordsApi();
    }
  }

  return (
    <>
    <Collapse
      activeKey={checkBox?.no_ld_records ? checked?.key : ["1", "2", "3"]}
      onChange={(e) => {
        setChecked({ key: e });
      }}
    >
      <Panel
        header="Pending Litigation by Entity"
        key="1"
        extra={
          <Checkbox
            checked={appNoRcd?.no_ld_records}
            onChange={(e) => {
              setCheckBox({
                ...checkBox,
                no_ld_records: e.target.checked,
              });
              updateApplicationApi({ no_ld_records: e.target.checked });
            }}
          >
            No Information Identified
          </Checkbox>
        }
        collapsible={appNoRcd?.no_ld_records ? "disabled" : ""}
      >
        {" "}
        <div
          style={
            appNoRcd?.no_ld_records
              ? {
                  cursor: "not-allowed",
                }
              : {}
          }
        >
          <EntityLitigation
            disable={appNoRcd?.no_ld_records}
            recordBucket="pending_by_entity"
            title="Pending Litigation by Entity"
          />
        </div>
      </Panel>
      <Panel
        header="Pending Litigation against Entity"
        key="2"
        extra={
          <Checkbox
            checked={appNoRcd?.no_jd_records}
            onChange={(e) => {
              setCheckBox({
                ...checkBox,
                no_jd_records: e.target.checked,
              });
              updateApplicationApi({ no_jd_records: e.target.checked });
            }}
          >
            No Information Identified
          </Checkbox>
        }
        collapsible={appNoRcd?.no_jd_records ? "disabled" : ""}
      >
        <div
          style={
            appNoRcd?.no_jd_records
              ? {
                  cursor: "not-allowed",
                }
              : {}
          }
        >
          <EntityLitigation
            disable={appNoRcd?.no_jd_records}
            recordBucket="pending_against_entity"
            title="Pending Litigation against Entity"
          />
        </div>
      </Panel>
      <Panel
        header="Other"
        key="3"
        extra={
          <Checkbox
            checked={appNoRcd?.no_jc_records}
            onChange={(e) => {
              setCheckBox({
                ...checkBox,
                no_jc_records: e.target.checked,
              });
              updateApplicationApi({ no_jc_records: e.target.checked });
            }}
          >
            No Information Identified
          </Checkbox>
        }
        collapsible={appNoRcd?.no_jc_records ? "disabled" : ""}
      >
        {" "}
        <div
          style={
            appNoRcd?.no_jc_records
              ? {
                  cursor: "not-allowed",
                }
              : {}
          }
        >
          <EntityLitigation
            disable={appNoRcd?.no_jc_records}
            recordBucket="other"
            title="Other"
          />
        </div>
      </Panel>
    </Collapse>
    <div style={{ marginTop: 16 }}>
      <Button
        type="primary"
        size="large"
        onClick={() => props.onStepChange?.(props.currentStep + 1)}
      >
        Save & Continue to next section
      </Button>
    </div>
    </>
  );
};

export default NotableCourtRecords;
